import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AdminReceivedNotifications from "../../components/Admin Notification/AdminNotificationList";


const MyNotificationList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="My Notification" />

        {/* BookingListLayer */}
        <AdminReceivedNotifications />

      </MasterLayout>

    </>
  );
};

export default MyNotificationList; 
